import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import ActivityHeaderRow from "./ActivityHeaderRow";
import ActivityActions from "./ActivityActions";

export default function ActivityBlock({
  activityDetails,
  actIndex,
  activityNumber,
  onUpdate,
  onDelete,
  onAdd,
  onMoveActivity,
  onDrop,
  onMove,
  likelihoods,
  consequences,
  riskRatings,
  onRiskSave,
  isDisabled
}) {

  const ref = useRef(null);
  const handleRef = useRef(null);

  const [, drop] = useDrop({
    canDrop: () => !isDisabled,
    accept: "activity_rows",
    hover(item, monitor) {
      if (!ref.current) return;
      if (item.actIndex === actIndex) return;

      const rect = ref.current.getBoundingClientRect();
      const middleY = (rect.bottom - rect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - rect.top;

      if (item.actIndex < actIndex && hoverClientY < middleY) return;
      if (item.actIndex > actIndex && hoverClientY > middleY) return;

      onMoveActivity(item.actIndex, actIndex);

      item.actIndex = actIndex;
    },
    drop() {
      return { dropped: true };
    },

  });

  const [{ isDragging }, drag, preview] = useDrag({
    type: "activity_rows",
    item: {
      actIndex,
      originalActIndex: actIndex,
    },
    canDrag: () => !isDisabled,
    end: (item, monitor) => {
      const didDrop = monitor.didDrop();

      if (!didDrop) {
        return;
      }

      if (item.originalActIndex !== item.actIndex) {
        onDrop();
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  preview(ref);
  drop(ref)
  drag(handleRef);


  const list = Array.isArray(activityDetails.fm_swms_actions_v2)
    ? activityDetails.fm_swms_actions_v2
    : [];

  return (
    <tbody ref={ref} style={{ opacity: isDragging ? 0.3 : 1 }}>
      <ActivityHeaderRow
        actIndex={actIndex}
        activityNumber={activityNumber}
        activityName={activityDetails.activity_name}
        onUpdate={onUpdate}
        onDelete={onDelete}
        isDisabled={isDisabled}
        handleRef={handleRef}
        onAdd={onAdd}
      />

       {list.map((action, actionIndex) => (
        <ActivityActions
          key={action.id ? action.id : `action_${actIndex}_${actionIndex}`}
          action={action}
          actionIndex={actionIndex}
          actIndex={actIndex}
          activityNumber={activityNumber}
          actionCount={list.length}
          isDisabled={isDisabled}
          actId={activityDetails.activity_id}
          likelihoods={likelihoods}
          onRiskSave={onRiskSave}
          allConsequences={consequences}
          riskRatings={riskRatings}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onAdd={onAdd}
          onMove={onMove}
          onDrop={onDrop}
        />
      ))}
    </tbody>
  );
}